module.exports = __webpack_public_path__ + "static/Happy-robot-hero-06fad54904dbe6abae080d4dc8b293f1.jpg";